<template>
  <v-textarea
    v-model="message"
    auto-grow
    class="text-caption"
    clearable
    dense
    outlined
    :clear-icon="mdiCloseCircle"
    :disabled="disabled"
    :placeholder="placeholder"
  >
    <template #label>
      <span class="info--text">
        {{ label }}
        <span
          v-if="required"
          class="red--text"
        >
          *
        </span>
      </span>
    </template>
  </v-textarea>
</template>

<script>
import { mdiCloseCircle } from '@mdi/js';

export default {
  name: 'BaseFormTextArea',
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  emits: ['input'],
  data() {
    return {
      mdiCloseCircle,
    };
  },
  computed: {
    message: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
